import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import CinematicJourney from "@/components/journey/CinematicJourney";
import WhatWeDoSection from "@/components/home/WhatWeDoSection";
import WhoWeWorkWithSection from "@/components/home/WhoWeWorkWithSection";
import FinalCTA from "@/components/FinalCTA";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Startseite: cinematische Scroll-Journey (Großspeicher → Digital Twin → KI-Agenten),
 * darunter „Drei Dinge" und „Für wen" (Nico 04.09.2026, Variante C).
 */
const Index = () => {
  const { t } = useLanguage();
  return (
    <div className="eg-journey-page min-h-screen flex flex-col">
      <SEO
        title="ENERGIEGLÜCK – Großspeicher. Und die KI dahinter."
        description="Energieglück entwickelt, baut und betreibt Großspeicher und die KI-Agenten, die sie steuern. Dieselben Agenten arbeiten für Stadtwerke und Versorger in Prozessen, Dokumenten und Kundenkommunikation."
        path="/"
      />
      <Navigation />
      <main>
        <CinematicJourney />
        <div className="eg-journey-fade" aria-hidden="true" />
        <WhatWeDoSection />
        <WhoWeWorkWithSection />
        <FinalCTA
          variant="split"
          title={t("home.join.title")}
          description={t("home.join.subtitle")}
          primaryLabel={t("home.join.ctaPrimary")}
          primaryTo="/kontakt"
          note={t("home.join.trust")}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
